module.exports = __webpack_public_path__ + "assets/img/kv-mo.ab7c731a.jpg";